import React from "react";
import {
  Select as ShadcnSelect,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../shadcn/select";

export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

export interface CustomSelectProps {
  options: SelectOption[];
  value?: string;
  onValueChange?: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  "aria-label"?: string;
  "data-testid"?: string;
}

export const Select: React.FC<CustomSelectProps> = ({
  options,
  value,
  onValueChange,
  placeholder = "Select an option...",
  disabled = false,
  className = "",
  "aria-label": ariaLabel,
  "data-testid": dataTestId,
}) => {
  if (!options || options.length === 0) {
    return (
      <div className="text-sm text-muted-foreground p-2">
        No options available
      </div>
    );
  }

  const handleValueChange = (newValue: string) => {
    if (onValueChange && !disabled) {
      onValueChange(newValue);
    }
  };

  return (
    <ShadcnSelect
      value={value}
      onValueChange={handleValueChange}
      disabled={disabled}
    >
      <SelectTrigger
        className={className}
        aria-label={ariaLabel}
        data-testid={dataTestId}
        tabIndex={disabled ? -1 : 0}
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem
            key={option.value}
            value={option.value}
            disabled={option.disabled}
            className="cursor-pointer"
          >
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </ShadcnSelect>
  );
};
